/* globals Swiper */
'use strict';

const swiper = new Swiper('.swiper .swiper-container', {
    loop: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
    pagination: {
        el: ".swiper-pagination",
    }
});

import PhotoSwipeLightbox from 'https://unpkg.com/photoswipe@5.3.7/dist/photoswipe-lightbox.esm.js';

const photo_swipe_options = {
  gallery: '.swiper-container',
  pswpModule: () => import('https://unpkg.com/photoswipe@5.3.7/dist/photoswipe.esm.js'),
  // set background opacity
  bgOpacity: 1,
  showHideOpacity: true,
  children: 'a',
  loop: true,
  showHideAnimationType: 'zoom', /* options: fade, zoom, none */

  /* Click on image moves to the next slide */
  imageClickAction: 'next',
  tapAction: 'next',

  /* ## Hiding a specific UI element ## */
  zoom: false,
  close: true,
  counter: true,
  arrowKeys: true,
  /* ## Options ## */
  bgOpacity: "1",/* deafult: 0.8 */
  wheelToZoom: true, /* deafult: undefined */
};

const lightbox = new PhotoSwipeLightbox(photo_swipe_options);

lightbox.init();

lightbox.on('change', () => {
  const { pswp } = lightbox;
  swiper.slideTo(pswp.currIndex, 0, false);
  //console.log('Slide index', pswp.currIndex);
  //console.log('Slide object', pswp.currSlide);
  //console.log('Slide object data', pswp.currSlide.data);
});

lightbox.on('afterInit', () => {
  const { pswp } = lightbox;
  if(swiper.params.autoplay.enabled){
    swiper.autoplay.stop();
  };
  console.log('afterInit');
});


lightbox.on('closingAnimationStart', () => {
  //console.log('closingAnimationStart');
  const { pswp } = lightbox;
  swiper.slideTo(pswp.currIndex, 0, false);
  /* if autoplay enabled == true -> autoplay.start() when close lightbox */
  if(swiper.params.autoplay.enabled){
    swiper.autoplay.start();
  }
});